export default {
      id: "oc-unstar-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-unstar",
      toString: function () {
        return this.url;
      }
    }